import z from 'zod'

import {ErrorSchema, PagingSchema} from 'src/feature/bite/domain'

export const createDetailResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    responseResult: ErrorSchema,
    response: dataSchema,
  })
}

export const createListResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    responseResult: ErrorSchema,
    response: z.object({
      dataList: dataSchema,
      paging: PagingSchema,
    }),
  })
}
export const createVIPDetailResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
    }),
    vipTierData: dataSchema,
  })
}

export const createVIPProgramResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
    }),
    vipProgramData: dataSchema,
  })
}

export const createReferralProgramResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
    }),
    referralProgramData: dataSchema,
  })
}

export const createVIPListResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
    }),
    data: dataSchema,
    paging: PagingSchema,
  })
}

export const createVIPCampaignListResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
    }),
    data: dataSchema,
    paging: PagingSchema,
  })
}

export const createVIPCampaignProductListResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  // return z.object({
  //   responseResult: ErrorSchema,
  //   response: z.object({
  //     dataList: dataSchema,
  //     paging: PagingSchema,
  //   }),
  // })
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
      customerMessage: z.string().nullable(),
    }),
    data: dataSchema,
    paging: PagingSchema,
  })
}

export const createReferralCampaignProductListResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    result: z.object({
      isSuccess: z.boolean(),
      errorMessage: z.string().nullable(),
      errorCode: z.string().nullable(),
      customerMessage: z.string().nullable(),
    }),
    data: dataSchema,
    paging: PagingSchema,
  })
}

export const createTrxListResponseSchema = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    responseResult: ErrorSchema,
    response: z.object({
      transactions: dataSchema,
      //paging: PagingSchema,
    }),
  })
}

export const createListResponseSchemaMembers = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    responseResult: ErrorSchema,
    response: z.object({
      members: dataSchema,
      paging: PagingSchema,
    }),
  })
}

export const createListResponseSchemaDefault = <T>(dataSchema: z.ZodType<T>) => {
  return z.object({
    responseResult: ErrorSchema,
    response: dataSchema,
  })
}

export const SmsSchema = z.object({
  mobilePhone: z.string().nullable(),
  title: z.string().nullable(),
  status: z.number(),
  sentTime: z.string().nullable(),
  deliveryTime: z.string().nullable(),
  createdOn: z.string().nullable(),
  message: z.string().nullable(),
  sender: z.string().nullable(),
  allowChanges: z.boolean(),
})

export const PushSchema = z.object({
  token: z.string().nullable(),
  title: z.string().nullable(),
  status: z.number(),
  sentTime: z.string().nullable(),
  deliveryTime: z.string().nullable(),
  createdOn: z.string().nullable(),
  message: z.string().nullable(),
  sender: z.string().nullable(),
  opened: z.boolean(),
  clicked: z.boolean(),
})

export const EmailSchema = z.object({
  emailAddress: z.string().nullable(),
  title: z.string().nullable(),
  status: z.number(),
  sentTime: z.string().nullable(),
  deliveryTime: z.string().nullable(),
  readTime: z.string().nullable(),
  createdOn: z.string().nullable(),
  subject: z.string().nullable().optional(),
  message: z.string().nullable(),
  sender: z.string().nullable(),
  read: z.boolean(),
  result: z.string().nullable(),
})

// // Kullanımı:
// const StoreListSchemaResponse = createResponseSchema(StoreListItemSchema);

// // Ve tipi
// export type StoreListResponse = z.infer<typeof StoreListSchemaResponse>;
